import React from "react";
import { div, navigate, Link } from 'gatsby'
import {IconArrowNarrowRight, IconArrowNarrowLeft, IconArrowNarrowDown} from '@tabler/icons-react'
import { motion } from "framer-motion";


export default function MovilMenus(props) {

    const [isTouched, setIsTouched] = React.useState(false)

    const index = props.uri.slice(0, -1).lastIndexOf("/")
    const slug = props.uri.slice(index, -1)      

    const variants = {
        moveX: {transform: ['translateX(100%)', 'translateX(0%)'], visibility: ['hidden', 'visible'], transition: { duration: 0.4, type: 'spring' }},
        stop: {transform: ['translateX(0%)', 'translateX(100%)'], opacity: ['0', '100'], transition: { duration: 0.4, type: 'spring' } }
        
    }

    const columns = props.subMenu.children && props.subMenu.children.map((child)=>{

        return(
            <SubMenuItem label={child.label} children={child.children}/>
        )
    })

    return(
        <div className='flex flex-col'>
            <div className='group flex border-b border-charcoal border-solid min-h-[80px]'>
                <Link className="w-full h-[80px] pl-6 flex items-center group hover:bg-red" onTouchEnd={()=>navigate(props.url ? props.url : '/category' + slug)} ><h6 className='uppercase w-full -mb-2 text-base group-hover:text-white'>{props.label}</h6></Link>
                {props.subMenu.children && 
                    <div className="aspect-square h-full min-w-[80px] flex-1 flex justify-center items-center border-l hover:bg-red" onTouchEnd={()=>{setIsTouched(prevState=>!prevState)}}>
                        <IconArrowNarrowRight size={40} stroke={0.75} className={`transition-all ease-in-out duration-100`}/>
                    </div>
                }

            </div>

            {props.subMenu.children && <motion.div 
                className={`block absolute top-0 left-0 w-full h-[100vh] bg-cream z-50 translate-x-[100%]`}
                variants={variants}
                animate={isTouched ? 'moveX' : 'stop'}
            >
                <div className='group flex items-center justify-between px-6 py-4 border-b border-charcoal border-solid' onTouchEnd={()=>{setIsTouched(prevState=>!prevState)}}>
                    <h6 className='uppercase -mb-2 text-base text-center font-bold w-full text-center'>{props.label}</h6>
                    <IconArrowNarrowLeft size={40} stroke={0.75} className={`transition-all ease-in-out duration-100`}/>
                </div>

                {columns}
            </motion.div>}
        </div>

    )

    
}


export function SubMenuItem(props) {

    const [isTouched, setIsTouched] = React.useState(false)
    
    const variants = {
        down: {height: ['0px', 'fit-content'], visibility: ['hidden', 'visible'], transition: { duration: 0.4, type: 'spring' }},
        up: {height: ['fit-content', '0px'], visibility: ['visible', 'hidden'], transition: { duration: 0.4, type: 'spring' } }

    }

    const childs = props.children.map((listItem)=>{

        const index = listItem.uri.slice(0, -1).lastIndexOf("/")
        const slug = listItem.uri.slice(index, -1)

        return(
            <li className='mb-2 group w-fit' onTouchEnd={()=>{navigate(`/category${slug}`)}}>
                <div>{listItem.label}</div>
                <span className='block max-w-0 group-hover:max-w-full transition-all duration-500 h-[1px] bg-charcoal'></span>
            </li>
        )
    })
    // onTouchEnd={navigate(`/category${slug}`)}
    return(
        <div className="px-6 py-4 border-b border-charcoal border-solid">

            <div className='group flex items-center justify-between' onTouchEnd={()=>{setIsTouched(prevState=>!prevState)}}>
                <h6 className='uppercase -mb-2 text-base'>{props.label}</h6>
                <IconArrowNarrowDown size={40} stroke={0.75} className={`transition-all ease-in-out duration-100`}/>
            </div>

            <motion.div
                variants={variants}
                animate={isTouched ? 'down' : 'up'}
            >
                <ul className="pt-2">
                    {childs}
                </ul>
            </motion.div>
        </div>


    )
    
}